<template>
  <el-dialog
    :visible="true"
    width="700px"
    @close="$router.replace('/data/storages')"
    :close-on-click-modal="false"
  >
    <div
      slot="title"
    >
      {{ title }}
    </div>
    <el-tabs
      v-model="activeName"
      v-loading="loading">
      <el-tab-pane
        label="Alapadatok"
        name="1">
        <el-table
          :data="storageData"
          :show-header="false"
          border
        >
          <el-table-column
            prop="label"
          >
            <template slot-scope="scope">
              <strong>{{ scope.row.label }}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="value"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.tagType || 'danger'"
                size="small"
                v-if="scope.row.tag"
              >
                {{ scope.row.value }}
              </el-tag>
              <span
                v-if="!scope.row.tag"
                style="word-break: normal;"
              >
                {{ scope.row.value }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Készlet"
        name="3"
      >
        <el-input
          v-model="filterInput"
          class="filter-input"
          @keyup.enter.native="search"
          @keyup.native="search"
          size="small"
          style="margin-bottom: 15px; width: 230px"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search"
          />
        </el-input>
        <el-table
          :data="stockData"
          border
          class="stock-table"
          @expand-change="onExpandRow"
        >
          <el-table-column
            type="expand"
          >
            <template slot-scope="scope">
              <div
                v-loading="stockLoading === scope.row.id"
                style="margin: -20px 0px;"
              >
                <div v-if="stocks.find(s => s.id === scope.row.id)">
                  <el-card
                    v-for="stock in stocks.find(s => s.id === scope.row.id).packs"
                    v-if="stock.count"
                    :key="stock.id"
                    style="margin: 20px 0;"
                  >
                    <div
                      slot="header"
                    >
                      <strong>{{ stock.count }} <span v-if="stock.count_per_pack === 1">db</span><span v-else>{{ stock.pack_type.name }}</span></strong><span v-if="stock.count_per_pack !== 1"> ({{ stock.count * stock.count_per_pack }} db)</span>
                      <el-tag
                        v-if="stock.count_per_pack !== 1"
                        size="small"
                        type="info"
                        style="display: inline-block; float: right; margin-top: -3px;"
                      >
                        {{ stock.count_per_pack }} db / {{ stock.pack_type.name }}
                      </el-tag>
                    </div>
                    <h4 style="margin-top: 0;">Beszállítók / Szavatossági idők szerinti készlet</h4>
                    <div
                      v-for="supplier in stock.suppliers"
                      v-if="supplier.count"
                      :key="supplier.id"
                    >
                      {{ supplier.company.name }}<i class="el-icon-d-arrow-right" style="margin: 0 5px;"></i><strong>{{ supplier.count }} <span v-if="stock.count_per_pack === 1">db</span><span v-else>{{ stock.pack_type.name }}</span></strong><span v-if="stock.count_per_pack !== 1"> ({{ stock.count * stock.count_per_pack }} db)</span></strong>
                      <ul>
                        <li
                          v-for="expiration in supplier.expirations"
                          :key="expiration.id"
                          style="line-height: 1.5;"
                        >
                          {{ expiration.expiration_date | date }}<i class="el-icon-d-arrow-right" style="margin: 0 5px;"></i><strong>{{ expiration.count }} <span v-if="stock.count_per_pack === 1">db</span><span v-else>{{ stock.pack_type.name }}</span></strong><span v-if="stock.count_per_pack !== 1"> ({{ expiration.count * stock.count_per_pack }} db)</span>
                        </li>
                      </ul>
                    </div>
                  </el-card>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Termék"
            prop="name"
            class-name="product-column"
            min-width="200"
            sortable
          />
          <el-table-column
            label="Mennyiség"
            prop="count"
            width="140"
            sortable
          >
            <template slot-scope="scope">
              {{ scope.row.count }} db
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="Napló"
        name="2"
      >
        <activity-timeline
          v-if="storage && storage.activities"
          :activities="storage.activities"
          :formatters="activityFormatters"
          :propsMap="propsMap"
        />
      </el-tab-pane>
    </el-tabs>
    <div
      slot="footer"
      class="dialog-footer"
      v-can="['storage.delete', 'storage.update']"
    >
      <el-button
        @click="$router.replace('/data/storages/update/' + storage.id)"
        type="primary"
        icon="el-icon-edit"
        v-can="'storage.update'"
      >
        Módosítás
      </el-button>
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteStorage()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          icon="el-icon-delete"
          type="danger"
          style="margin-left: 5px;"
        >
          Törlés
        </el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
import ActivityTimeline from '../../../components/ActivityTimeline';

export default {
  components: { ActivityTimeline },
  props: ['storageId'],
  data() {
    return {
      stockLoading: 0,
      stocks: [],
      activeName: '1',
      deleteButtonLoader: false,
      deleteConfirmVisible: false,
      title: 'Betöltés folyamatban...',
      loading: false,
      buttonLoading: false,
      filterInput: '',
      storage: {},
      storageData: [],
      stockData: [],
      activityFormatters: {
        is_active: status => ({
          value: status ? 'Aktív' : 'Inaktív',
          tag: status ? 'success' : 'danger',
        }),
        type: type => ({
          value: type === 'representative' ? 'Képviselői raktár' : 'Központi raktár'
        })
      },
      propsMap: {
        'name': 'Név',
        'is_active': 'Státusz',
        'type': 'Típus',
        'user': 'Képviselő',
        'deputy_user': 'Képviselő helyettes',
        'address_id': 'Cím',
        'country_id': 'Ország',
        'county_id': 'Megye',
      },
    };
  },

  async mounted() {
    await this.fetchData();
  },
  methods: {
    async onExpandRow(row) {
      this.stockLoading = row.id;
      const stocks = await axios.get(`/api/products/${row.id}/storage/${this.storage.id}`);
      this.stocks.push(stocks);
      this.stockLoading = 0;
    },
    async fetchData() {
      this.loading = true;
      this.storage = await axios.get(`api/storages/${this.storageId}`);
      this.title = this.storage.name;
      this.stockData = JSON.parse(JSON.stringify(this.storage.stocks));
      this.storageData = [
        {
          label: 'Név',
          value: this.storage.name
        },
        {
          label: 'Típus',
          value: this.storage.type ? (this.storage.type === 'representative' ? 'Képviselői raktár' : 'Központi raktár') : '',
        },
        {
          label: 'Képviselő',
          value: this.storage.user && this.storage.user.last_name + ' ' + this.storage.user.first_name
        },
        {
          label: 'Képviselő helyettes',
          value: this.storage.deputy_user && this.storage.deputy_user.last_name + ' ' + this.storage.deputy_user.first_name
        },
        {
          label: 'ILN',
          value: this.storage.iln || '-'
        },
        {
          label: 'Irányítószám',
          value: this.storage.address && this.storage.address.postal_code
        },
        {
          label: 'Város',
          value: this.storage.address && this.storage.address.city,
        },
        {
          label: 'Ország',
          value: this.storage.address && this.storage.address.country && this.storage.address.country.name
        },
        {
          label: 'Cím',
          value: this.storage.address && this.storage.address.address
        },
        {
          label: 'Státusz',
          value: this.storage.is_active ? 'Aktív' : 'Inaktív',
          tag: true,
          tagType: this.storage.is_active ? 'success' : 'danger',
        },
      ];
      this.loading = false;
    },
    async deleteStorage() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('storage/delete', this.storage.id);
        this.$store.dispatch('storage/fetchAll');
        this.$router.replace('/data/storages');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },

    search() {
      this.stockData = this.storage.stocks.filter(data => data.name.toLocaleLowerCase()
        .indexOf(this.filterInput.toLocaleLowerCase()) !== -1);
    },

    getStatusValue(status) {
      switch (status) {
        case 'in-progress':
          return 'Folyamatban';
        case 'done':
          return 'Kész';
        case 'todo':
          return 'Elintézendő';
      }
    }
  },
};
</script>
<style lang="scss">
  .stock-table {
    .product-column {
      .cell {
        word-break: break-word;
      }
    }
  }

</style>

